// APP FRONTEND
export const APP_DOMAIN = '';
export const APP_SUBPATH = '';

// FIREBASE

export const GOOGLE_GEOCODE_API_KEY = 'AIzaSyBOWNQ0VD1AvJuYZwvQUdohHhJA_DCEIEo';
